module.exports = __webpack_public_path__ + "img/sld_inverter_red_t1_dark.3a757b61.svg";